// src/pages/Members.js
import { useEffect, useState } from 'react';
import API from '../api/axios';
import './Members.css';

const Members = () => {
  const [members, setMembers] = useState([]);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  useEffect(() => {
    const params = {};
    if (filter !== 'all') params.status = filter;
    API.get('/members', { params })
      .then(res => setMembers(res.data))
      .catch(console.error);
  }, [filter]);

  const filtered = members.filter(m =>
    m.username?.toLowerCase().includes(search.toLowerCase()) ||
    m.full_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="members-page">
      <div className="page-header">
        <h1>👥 Members</h1>
        <div className="header-controls">
          <input
            className="search-input"
            type="text"
            placeholder="🔍 Kullanıcı ara..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <select className="filter-select" value={filter} onChange={e => setFilter(e.target.value)}>
            <option value="all">Tümü</option>
            <option value="active">Aktif</option>
            <option value="expired">Süresi Dolmuş</option>
            <option value="cancelled">İptal Edilmiş</option>
          </select>
        </div>
      </div>
      <div className="table-container">
        <table className="members-table">
          <thead>
            <tr>
              <th>Kullanıcı</th>
              <th>Paket</th>
              <th>Başlangıç</th>
              <th>Bitiş</th>
              <th>Ödenen</th>
              <th>Durum</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(m => (
              <tr key={m.id}>
                <td>
                  <div className="user-cell">
                    <span className="user-avatar">{m.full_name?.[0] || m.username?.[0] || '?'}</span>
                    <div>
                      <div className="user-name">{m.full_name || 'İsimsiz'}</div>
                      <div className="user-username">@{m.username || m.telegram_id}</div>
                    </div>
                  </div>
                </td>
                <td>{m.package_name}</td>
                <td>{new Date(m.start_date).toLocaleDateString('tr-TR')}</td>
                <td>{new Date(m.end_date).toLocaleDateString('tr-TR')}</td>
                <td>{m.total_paid} USDT</td>
                <td>
                  <span className={`status-tag ${m.status}`}>
                    {m.status === 'active' ? 'Aktif' : m.status === 'expired' ? 'Süresi Doldu' : 'İptal'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Members;